export enum DealerLogoDisplay {
    UseLogo = 1,
    NoLogoUseText = 2,
    NoLogoNoText = 3,
}
